import React from 'react';
import EstimotoApp from './startup/EstimotoApp';

function App() {
  return (
    <div className="App">
      <EstimotoApp />
    </div>
  );
}

export default App;
